"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 20 24';

var Copy = function Copy() {
  return _react["default"].createElement("g", null, _react["default"].createElement("rect", {
    x: ".6",
    y: ".6",
    width: "14.105",
    height: "17.513",
    ry: "2.6716",
    fill: "none",
    strokeLinejoin: "round",
    strokeOpacity: ".5",
    strokeWidth: "1.2116"
  }), _react["default"].createElement("rect", {
    x: "5.2435",
    y: "5.7292",
    width: "14.105",
    height: "17.513",
    ry: "2.6716",
    fill: "none",
    strokeLinejoin: "round",
    strokeWidth: "1.2116"
  }));
};

var _default = (0, _createSvgIcon["default"])(Copy, {
  viewBox: viewBox,
  enableStroke: true
});

exports["default"] = _default;